module.exports = __webpack_public_path__ + "img/orange-circle-table-8.6e77045c.png";